import React, { useEffect, useState } from 'react';

import { FlightSearchBarActionType } from '@contexts/searchbar/types/flight';
import Segmented from '@components/Segmented/Segmented';
import { FlightTripType } from '@components/views/flight/types';
import { flightTripOptions } from '@components/views/flight/constants';
import useSearchbar from '@contexts/searchbar';

import { Wrapper } from './styled';

const TripSelection = () => {
  const {
    state: { flight: state },
    dispatch,
  } = useSearchbar();

  const [tripType, setTripType] = useState<FlightTripType>('round-trip');

  useEffect(() => {
    setTripType(state?.isOneWay ? 'one-way' : 'round-trip');
  }, [state.isOneWay]);

  const handleChange = (value: FlightTripType) => {
    setTripType(value);
    dispatch({
      type: FlightSearchBarActionType.SET_IS_ONE_WAY,
      payload: value === 'one-way',
    });
  };

  return (
    <Wrapper>
      <Segmented
        options={flightTripOptions}
        value={tripType}
        onChange={handleChange}
      />
    </Wrapper>
  );
};

export default TripSelection;
